import { ChevronDown } from '../ui/icons';
import { useT } from '../../i18n';
import { getProviderIconUrl } from '../../data/cryptoData';
import type { Quote } from '@nowramp/sdk';

export interface ProviderCardProps {
  selectedQuote: Quote | null;
  quotesLoading: boolean;
  onOpenModal: () => void;
  assetBaseUrl?: string;
}

export function ProviderCard({
  selectedQuote,
  quotesLoading,
  onOpenModal,
  assetBaseUrl = '',
}: ProviderCardProps) {
  const t = useT();
  return (
    <div
      role="button"
      tabIndex={0}
      onClick={onOpenModal}
      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') onOpenModal(); }}
      className="flex items-center gap-[4px] p-4 transition-colors cursor-pointer card-press card-hover"
      style={{
        background: 'var(--t-surface)',
        borderRadius: 'var(--t-card-radius)',
      }}
    >
      <span className="text-[13px] flex-1" style={{ color: 'var(--t-text-secondary)', letterSpacing: '0.13px', lineHeight: '20px' }}>
        {t('provider.label')}
      </span>
      <span className="flex items-center gap-[6px]">
        {quotesLoading && !selectedQuote && (
          <span className="text-[13px]" style={{ color: 'var(--t-text-muted)' }}>...</span>
        )}
        {!quotesLoading && !selectedQuote && (
          <span className="text-[13px]" style={{ color: 'var(--t-text-muted)' }}>{t('provider.select')}</span>
        )}
        {selectedQuote && (
          <>
            <span className="flex items-center justify-center overflow-hidden rounded-full" style={{ width: 20, height: 20 }}>
              <img
                src={getProviderIconUrl(selectedQuote.gatewayId, assetBaseUrl)}
                alt=""
                width={20}
                height={20}
                className="rounded-full"
                style={{ width: 20, height: 20, objectFit: 'cover' }}
                onError={(e) => {
                  if (selectedQuote.gatewayLogo && (e.target as HTMLImageElement).src !== selectedQuote.gatewayLogo) {
                    (e.target as HTMLImageElement).src = selectedQuote.gatewayLogo;
                  }
                }}
              />
            </span>
            <span className="text-[14px] font-semibold" style={{ color: 'var(--t-text)', letterSpacing: '0.14px', lineHeight: '16px' }}>
              {selectedQuote.gatewayName}
            </span>
          </>
        )}
        <ChevronDown />
      </span>
    </div>
  );
}
